import { render, staticRenderFns } from "./WaterfallChartHandler.vue?vue&type=template&id=35052d52"
import script from "./WaterfallChartHandler.vue?vue&type=script&lang=ts"
export * from "./WaterfallChartHandler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports